export interface NavItem {
  href: string;
  label: string;
  /** Desktop: show icon + tooltip instead of text label. Mobile/footer still use `label`. */
  iconOnly?: boolean;
}

/** Primary nav — Donate is a dedicated CTA in the pill, not duplicated here. */
export const mainNav: NavItem[] = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/programs", label: "Programs" },
  { href: "/impact", label: "Impact" },
  { href: "/events", label: "Events" },
  { href: "/contact", label: "Contact" },
];

export {
  footerQuickLinks,
  footerPrograms,
} from "@/content/footer";
